export type LocalUser = {
  id: string;
  email: string;
  role?: string;
  tenant_id?: string;
  learner_id?: string | null;
  app_metadata?: { tenant_id?: string; learner_id?: string };
};
export type LocalSession = { access_token: string; expires_at: number; user: LocalUser };
const KEY = "skola.local.session";
export function readSession(): LocalSession | null {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const s = JSON.parse(raw) as LocalSession;
    return s.expires_at > Date.now() / 1000 ? s : null;
  } catch {
    return null;
  }
}
export function writeSession(s: LocalSession): void {
  localStorage.setItem(KEY, JSON.stringify(s));
}
export function clearSession(): void {
  localStorage.removeItem(KEY);
}
export function accessToken(): string | null {
  return readSession()?.access_token ?? null;
}
